// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"441":"8b6de982","453":"7c337e16"}[chunkId] + ".chunk.js";
};